import { useEffect, useState } from "react";
import { MdClose } from "react-icons/md";
import { useDispatch } from "react-redux";
import {
  GetRefundRequestList,
  PaymentRefundRequest,
  VfsLoader,
} from "../../../Redux/Action/VfsAction";

export const RefundPaymentStatus = ({
  setRefundModal,
  userDetail,
  refundRequestList,
}) => {
  const dispatch = useDispatch();
  // get token from local storage
  const authToken = localStorage.getItem("Admin");
  const token = JSON.parse(authToken)?.data?.token;

  const [note, setNote] = useState("");
  const [error, setError] = useState("");
  const [refundRequest, setRefundRequest] = useState("");

  useEffect(() => {
    dispatch(GetRefundRequestList(userDetail?.transactionId));
  }, []);

  useEffect(() => {
   if(refundRequestList){
    setNote(refundRequestList?.note);
    setRefundRequest(refundRequestList?.status)
   }
  }, [refundRequestList]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = {
        note,
        memberId: userDetail?._id,
        transactionId: userDetail?.transactionId,
      };
      dispatch(PaymentRefundRequest(data, setRefundModal));
      dispatch(VfsLoader());
    } catch (error) {
    }
  };

  return (
    <>
      <div className="bg-black fixed  top-0 left-0 right-0 w-full h-full z-30 bg-opacity-50">
        <div
          className={
            refundRequest === "pending"
              ? "bg-white absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 shadow-xl rounded-[10px] w-[500px]"
              : "bg-white absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 shadow-xl rounded-[10px] "
          }
        >
          <div className="rounded-t-2xl px-5 md:px-3 xl:px-5 py-2 xl:py-3 uppercase font-Poppins text-xl  flex justify-between items-center">
            <div className="text-[18px] xl:text-xl">Payment Refund Request</div>
            <button
              onClick={() => {
                setRefundModal(false);
              }}
            >
              <MdClose className="text-gray-500 text-2xl hover:text-black" />
            </button>
          </div>
          <hr></hr>
          {refundRequest === "pending" ? (
           <div className="p-5 md:p-3 xl:p-5 flex flex-col gap-3">
             <div className="flex flex-col gap-1">
               <textarea
                 className="py-[10px] xl:py-3 px-4 rounded-lg bg-[#FFFCE1] text-sm  outline-[#FCDD00] input cursor-not-allowed resize-none" 
                 placeholder="Enter Refund Reason"
                 id="note "
                 name="note "
                 value={note}
                 onChange={(e) => {
                   const enteredValue = e.target.value;
                   const trimmedValue = enteredValue.trim();
                   if (trimmedValue !== "" || enteredValue === "") {
                     setNote(enteredValue);
                   }
                 }}
                 disabled
                 autoComplete="off"
               />
             </div>
         </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="p-5 md:p-3 xl:p-5 flex flex-col gap-3">
                <div className="md:flex gap-3">
                  <div className="flex flex-col gap-1">
                   
                    <textarea
                      className="py-[10px] xl:py-3 px-4 rounded-lg bg-[#FFFCE1] text-sm w-[500px] outline-[#FCDD00] input"
                      placeholder="Enter Refund Reason"
                      id="note "
                      name="note "
                      value={note}
                      onChange={(e) => {
                        const enteredValue = e.target.value;
                        const trimmedValue = enteredValue.trim();
                        if (trimmedValue !== "" || enteredValue === "") {
                          setNote(enteredValue);
                        }
                      }}
                      required
                      autoComplete="off"
                      maxLength={50}
                    />
                  </div>
                </div>

                <div>
                  {error && (
                    <p className="mt-2 text-[#FF0101] text-sm font-Poppins">
                      {error}
                    </p>
                  )}
                </div>
                <div className="md:flex justify-between md:items-end">
                  <div className="mt-2 md:mt-0 md:flex ml-auto justify-end">
                    <button
                      type="submit"
                      className="bg-[#FCDD00] text-[#1A1A1A] w-[100px] px-5 py-2 rounded-lg font-Poppins text-lg flex items-center justify-center gap-1 cursor-pointer hover:scale-105 outline-none"
                    >
                      Request
                    </button>
                  </div>
                </div>
              </div>
            </form>
          )}
        </div>
      </div>
    </>
  );
};
